import { images } from '../constants'; 

const events = [  
    {
        id: 1,
        image: images.event1,
        title: "events.item1.title",
        details: {
            date: "events.item1.date",
            location: "Dwór Imielno",
        },
        gallery: [
            images.event1Gallery1,
        ],
    },
    {
        id: 2,
        image: images.event2,
        title: "events.item2.title",
        details: {
            date: "events.item2.date",
            location: "Dwór Imielno",
        },
        gallery: [
            images.event1Gallery1,
        ],
    },
];

export default events;